import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Button } from "reactstrap";
import HoverImage from "react-hover-image/build";
import API from "utils/API";
import ReactStrapTable from "components/reactStrapTable";
import commonColumns from "utils/columns";
import Drawer from "components/Drawer";
import Comments from "../../../../common/Comments";
import ErrorBoundary from "components/ErrorBoundary";
import AttachIcon from "assets/icon/icon-icon-options-attachment.svg";
import AttachHoverIcon from "assets/icon/icon-icon-options-attachment_hover.svg";

const HistoricalClaims = ({ onDataLoading, refresh }) => {
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "",
    order: "",
    filters: [],
  };

  const { patientId, tenantID } = useParams();
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);
  const [isOpen, setOpen] = useState(false);
  const [claim, setClaim] = useState({});

  const fetchHistoricalClaims = async (filters = {}) => {
    onDataLoading(true);
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/Historical/${parseInt(patientId)}`,
        filters
      );
      if (data) {
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
      onDataLoading(false);
    } catch (error) {
      onDataLoading(false);
    }
  };

  useEffect(() => {
    fetchHistoricalClaims(initialFilters);
  }, [refresh]);

  const formatter = (row, columnName) => {
    return <>{row[columnName] || "-"}</>;
  };

  const columns = [
    {
      dataField: "attachement",
      text: "Options",
      cellRenderer: (rowData) => attachFile(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "rxNumber",
      text: "RX#",
      sort: true,
      headerStyle: { width: "90px" },
      cellRenderer: (row) => formatter(row, "rxNumber"),
      inputType: "number",
    },
    ...commonColumns,
  ];

  columns.splice(8, 1);

  const attachFile = (claim) => {
    return (
      <div className="d-flex align-items-center">
        {/* <Input
        onChange={() => onChange(claim)}
        type="checkbox"
        className="me-2 mt-0"
      /> */}
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleDrawer(claim)}
        >
          <HoverImage src={AttachIcon} hoverSrc={AttachHoverIcon} alt="" />
        </Button>
      </div>
    );
  };

  const toggleDrawer = (claim) => {
    setClaim(claim);
    setOpen(!isOpen);
  };

  function onPageChange(filter, hasColFilter, colChangedFilter) {
    if (hasColFilter) {
      let combine = { ...filter, filters: [...colChangedFilter] };
      fetchHistoricalClaims(combine, true);
      setInitFilter(combine);
    } else {
      fetchHistoricalClaims(filter);
      setInitFilter(filter);
    }
  }

  const handleSort = (filter) => {
    setInitFilter(filter);
    fetchHistoricalClaims(filter);
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchHistoricalClaims(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    const filter = { ...initFilter, filters: [] };
    setInitFilter(filter);
    fetchHistoricalClaims(filter);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let combine = { ...filter, filters: colChangedFilter };
      fetchHistoricalClaims(combine, true);
      setInitFilter(combine);
    } else {
      fetchHistoricalClaims(filter);
      setInitFilter(filter);
    }
  };

  return (
    <div
      className="table-card scroll-table position-relative border-0"
      fixed-height={data.length > 0 ? "fixed-height" : "default"}
    >
      <ReactStrapTable
        id="historical-claims"
        height={50 * data.length}
        fixedColumn
        width={1200}
        columns={columns}
        data={data}
        handleSort={handleSort}
        loader
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        hasPagination
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={onPageChange}
        filters={initFilter}
      ></ReactStrapTable>
      <Drawer
        direction="end"
        isOpen={isOpen}
        toggle={toggleDrawer}
        title="Claim Comments"
      >
        <ErrorBoundary>
          <Comments
            hasEditable={false}
            rxNumber={claim.rxNumber}
            onClose={toggleDrawer}
          />
        </ErrorBoundary>
      </Drawer>
    </div>
  );
};

export default HistoricalClaims;
